import React from 'react';
import { Coffee, MapPin, Phone } from 'lucide-react';

const CultivarCafe = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section
        className="relative h-[500px] flex items-center justify-center text-white"
        style={{
          backgroundImage: 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/urf6j6d5_IMG_3731.JPG)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-6">
            <img
              src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/jkkcntgo_cafeeee.png"
              alt="Cultivar Café"
              className="h-32 mx-auto drop-shadow-2xl"
            />
          </div>
          <p className="text-2xl max-w-3xl mx-auto">
            Atendemos a cafeicultura nas melhores regiões produtoras de Rondônia
          </p>
        </div>
      </section>

      {/* Description */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Atendimento ao Segmento de Café</h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                Atuamos no segmento de <strong>cafeicultura</strong> nas regiões do <strong>Vale do Guaporé</strong>, <strong>Cacoal</strong> e <strong>Zona da Mata</strong>, fornecendo insumos, sementes, defensivos e suporte aos produtores das principais áreas cafeeiras de Rondônia.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                Trabalhamos ao lado dos cafeicultores parceiros oferecendo as melhores soluções para a lavoura deles.
              </p>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="bg-green-100 p-2 rounded-full flex-shrink-0">
                    <Coffee className="w-5 h-5 text-green-600" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 mb-1">Parceria com o Produtor</h4>
                    <p className="text-gray-600">Atendimento próximo aos cafeicultores da região</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="bg-blue-100 p-2 rounded-full flex-shrink-0">
                    <MapPin className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 mb-1">Regiões Atendidas</h4>
                    <p className="text-gray-600">Vale do Guaporé, Cacoal e Zona da Mata - RO</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="h-96 rounded-xl shadow-2xl bg-cover bg-center"
              style={{
                backgroundImage: 'url(https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/xr9n0tik_IMG_3730.JPG)',
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* Galeria do Café - regional */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-3">A Cafeicultura na Nossa Região</h2>
          <p className="text-gray-600 text-base md:text-lg text-center mb-12 max-w-3xl mx-auto">
            Imagens das lavouras dos nossos clientes cafeicultores em Rondônia.
          </p>
          <div className="grid md:grid-cols-3 gap-6 mb-6">
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/urf6j6d5_IMG_3731.JPG"
                alt="Lavoura de café de cliente parceiro"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/xr9n0tik_IMG_3730.JPG"
                alt="Plantação de café na região"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/416xolpz_IMG_3780.JPG"
                alt="Colheita de café"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-6 mb-6">
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/ff9r4cvd_IMG_3779.JPG"
                alt="Frutos de café maduros"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/b420zmym_IMG_3776.JPG"
                alt="Mudas de café"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/pmneltvm_IMG_3782.JPG"
                alt="Cafezal com frutos"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/rnf2w9ab_IMG_3781.JPG"
                alt="Café maduro no pé"
                className="w-full h-96 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/t1efwkl9_IMG_3787.JPG"
                alt="Frutos de café vermelho"
                className="w-full h-96 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contato dos Responsáveis pelo Segmento de Café */}
      <section className="py-16 md:py-20 bg-amber-50" data-testid="cafe-contatos-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-3">Contato — Atendimento ao Cafeicultor</h2>
          <p className="text-gray-600 text-base md:text-lg text-center mb-10 max-w-2xl mx-auto">
            Fale diretamente com os responsáveis pelo atendimento ao segmento de café nas nossas regiões.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
            <div className="bg-white border-l-4 border-amber-700 rounded-lg shadow-sm hover:shadow-lg transition-shadow p-5" data-testid="cafe-card-baltazar">
              <div className="flex items-start space-x-3 mb-3">
                <Coffee className="w-6 h-6 text-amber-700 flex-shrink-0 mt-0.5" />
                <div>
                  <h3 className="font-bold text-lg text-gray-800">Atendimento — Vale do Guaporé e Zona da Mata</h3>
                  <p className="text-sm font-semibold text-amber-700 mt-1">Baltazar Fernandes</p>
                </div>
              </div>
              <a
                href="https://wa.me/5569984474778"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-700 hover:text-green-600 font-medium text-sm"
                data-testid="cafe-tel-baltazar"
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span>(69) 98447-4778</span>
              </a>
            </div>

            <div className="bg-white border-l-4 border-amber-700 rounded-lg shadow-sm hover:shadow-lg transition-shadow p-5" data-testid="cafe-card-luiz">
              <div className="flex items-start space-x-3 mb-3">
                <Coffee className="w-6 h-6 text-amber-700 flex-shrink-0 mt-0.5" />
                <div>
                  <h3 className="font-bold text-lg text-gray-800">Atendimento — Cacoal e Zona da Mata</h3>
                  <p className="text-sm font-semibold text-amber-700 mt-1">Luiz Augusto Catanio</p>
                </div>
              </div>
              <a
                href="https://wa.me/5569992753333"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-700 hover:text-green-600 font-medium text-sm"
                data-testid="cafe-tel-luiz"
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span>(69) 99275-3333</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA - Suporte ao Cafeicultor */}
      <section className="py-20 bg-gradient-to-r from-amber-700 to-amber-800 text-white text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Suporte ao Cafeicultor</h2>
          <p className="text-xl mb-8">
            Fornecemos insumos, sementes, defensivos e atendimento técnico para o segmento de café. Fale com a nossa equipe e saiba como podemos apoiar a sua lavoura.
          </p>
          <a
            href="/contato"
            className="inline-block bg-white text-amber-800 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            FALAR COM A EQUIPE
          </a>
        </div>
      </section>
    </div>
  );
};

export default CultivarCafe;
